/* 

*/

import Icemba from "pages/AcademiaCiber/icemba";

export default function IceMBAPage() {
  return <Icemba />;
}
